import assign from 'lodash/assign';

import DispatchConstants from 'app/shared/constants/DispatchConstants';

// models
import KeyPager from 'app/shared/model/KeyPager';

const initState = () => ({
    paidInclusionReleaseDates: [],
    paidInclusionExistingStatesUpdate: {},
    numTotalListings: 0,
    statsDaysBack: 0,
    listings: [],
    pager: KeyPager(),
    restrictions: {},
});

const properties = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.UPDATE_PROPERTIES_COUNT:
            return assign({}, state, payload);

        case DispatchConstants.UPDATE_PROPERTIES: {
            const { appendToListings, listingsModel } = payload;
            if (appendToListings) {
                return assign(
                    {},
                    state,
                    listingsModel,
                    { listings: [...state.listings, ...listingsModel.listings]}
                );
            }

            return assign({}, state, listingsModel);
        }

        default:
            return state;
    }
};

export default properties;
